<template>
  <div class="bb-notifications-bar-main">
    <div
      v-for="(item, index) in notifications"
      :key="item.id"
      class="bb-notifications-bar-main-item"
    >
      <i
        class="icon-cross bb-notifications-bar-main-item__icon-close"
        @click.stop="onDelete(index, item._id)"
      />
      <NotificationsBarMainPointer
        :item="item"
        @onReadNotification="onReadNotification"
      />
      <NotificationsBarMainIcon :item="item" />
      <component
        :is="routerTo(item) ? 'router-link' : 'div'"
        class="bb-notifications-bar-main-item-right"
        target="_blank"
        :to="routerTo(item)"
      >
        <div class="bb-notifications-bar-main-item-right__title">
          <span class="bb-notifications-bar-main-item-right__title_capitalize">
            {{createName(item)}}
          </span>
          <span v-if="USER_NOTIFICATION_COMMENT === item.eventNotification">
            left a comment in Project List
          </span>
        </div>
        <NotificationsBarMainMailing
          v-if="item.eventNotification === MAILING_NOTIFICATION"
          :item="item"
        />
        <NotificationsBarMainListOfProject
          v-else-if="item.eventNotification === LIST_OF_PROJECT_NOTIFICATION"
          :item="item"
        />
        <template v-else-if="CLIENT_NOTIFICATION_SYSTEM !== item.eventNotification">
          <div
            class="bb-notifications-bar-main-item-right__description"
            :class="[
              USER_NOTIFICATION_REMINDER === item.eventNotification &&
              'bb-notifications-bar-main-item-right__description_bold'
            ]"
          >
            {{ createDescription(item) }}
          </div>
          <div
            v-if="USER_NOTIFICATION_HR !== item.eventNotification"
            class="bb-notifications-bar-main-item-right__description"
          >
            {{ item.comment }}
          </div>
        </template>
        <NotificationsBarMainReject
          v-else-if="item.rejectComment"
          :item="item"
        />
        <NotificationsBarMainClient
          v-else
          :item="item"
        />
        <div
          class="
            bb-notifications-bar-main-item-right__description
            bb-notifications-bar-main-item-right__description_gray
          "
        >
         {{time(item)}}
        </div>
      </component>
    </div>
  </div>
</template>

<script>

import moment from 'moment'
import { NOTIFICATION_USER_HR_ID } from '@/constants/userTypeNotification'
import { HR_NOTIFICATION_RAED_STATUS_ID, HR_NOTIFICATION_NO_RAED_STATUS_ID } from '@/constants/hrNotificationReadStatus'
import TimeoffNotificationApi from '@/api/NotificationTimeoff/api'
import { MessageNotificationIcon } from '@/constants/icon'
import { USER_NOTIFICATION } from '@/constants/userNotification'
import NotificationsBarMainReject from '@/components/Notifications/NotificationsBar//NotificationsBarMainReject'
import NotificationsBarMainClient from '@/components/Notifications/NotificationsBar//NotificationsBarMainClient'
import NotificationsBarMainMailing from '@/components/Notifications/NotificationsBar/NotificationsBarMainMailing'
import NotificationsBarMainPointer from '@/components/Notifications/NotificationsBar/NotificationsBarMainPointer'
import NotificationsBarMainIcon from '@/components/Notifications/NotificationsBar/NotificationsBarMainIcon'
// eslint-disable-next-line max-len
import NotificationsBarMainListOfProject from '@/components/Notifications/NotificationsBar/NotificationsBarMainListOfProject'

export default {
  name: 'NotificationsBarMain',
  components: {
    NotificationsBarMainIcon,
    NotificationsBarMainPointer,
    NotificationsBarMainReject,
    NotificationsBarMainClient,
    NotificationsBarMainMailing,
    NotificationsBarMainListOfProject
  },
  props: {
    notificationsList: {
      type: Array,
      default: () => ([])
    }
  },
  data: () => ({
    MessageNotificationIcon,
    USER_NOTIFICATION_HR: USER_NOTIFICATION.USER_NOTIFICATION_HR,
    USER_NOTIFICATION_COMMENT: USER_NOTIFICATION.USER_NOTIFICATION_COMMENT,
    USER_NOTIFICATION_REMINDER: USER_NOTIFICATION.USER_NOTIFICATION_REMINDER,
    CLIENT_NOTIFICATION_SYSTEM: USER_NOTIFICATION.CLIENT_NOTIFICATION_SYSTEM,
    MAILING_NOTIFICATION: USER_NOTIFICATION.MAILING_NOTIFICATION,
    LIST_OF_PROJECT_NOTIFICATION: USER_NOTIFICATION.LIST_OF_PROJECT_NOTIFICATION,
    LIST_OF_ACADEMY_NOTIFICATION: USER_NOTIFICATION.LIST_OF_ACADEMY_NOTIFICATION
  }),
  computed: {
    notifications: {
      get () {
        return this.notificationsList
      },
      set (data) {
        this.$emit('update:notificationsList', data)
      }
    }
  },
  methods: {
    createDescription (item) {
      const {
        firstName,
        lastName,
        eventType,
        notificationStatus,
        startDate,
        userType,
        eventNotification,
        company,
        project = [],
        request = []
      } = item

      if (this.LIST_OF_ACADEMY_NOTIFICATION === eventNotification) {
        return '';
      }

      if (this.USER_NOTIFICATION_COMMENT === eventNotification) {
        return company[0].name
      } else if (this.USER_NOTIFICATION_REMINDER === eventNotification) {
        const [requestData = {}] = request
        const [projectData = {}] = project
        return projectData.name || requestData.name
      }
      const { name } = eventType
      const { desc, descFirst } = notificationStatus
      const date = moment(startDate).format('MMM D, YYYY')
      const time = moment(startDate).format('h:mm a')
      const textHr = `${firstName} ${lastName} ${desc} ${name} on`
      const textEmployee = `${descFirst} ${name} ${desc}`
      const text = userType !== NOTIFICATION_USER_HR_ID ? textHr : textEmployee
      return `${text} ${date} at ${time}`
    },
    createName ({notificationStatus, eventNotification, firstName, lastName, comment}) {
      if (this.USER_NOTIFICATION_HR === eventNotification) {
        return notificationStatus.name
      } else if (this.USER_NOTIFICATION_REMINDER === eventNotification) {
        return 'Reminder'
      } else if (this.CLIENT_NOTIFICATION_SYSTEM === eventNotification) {
        const items = comment.split(',')
        return items[items.length - 1]
      } else if (this.MAILING_NOTIFICATION === eventNotification) {
        return 'Mailing'
      } else if (this.LIST_OF_PROJECT_NOTIFICATION === eventNotification) {
        return 'Urgent Reminder'
      }
      else if (this.LIST_OF_ACADEMY_NOTIFICATION === eventNotification) {
        return comment;
      }
      return `${firstName} ${lastName}`
    },
    time ({requestDate}) {
      const date = moment(requestDate)
      const dateToday = moment(requestDate).format('DD-MMM-YY')
      const today = moment().format('DD-MMM-YY')
      return today === dateToday ? date.format('hh:mm A') : date.format('DD MMM YY, hh:mm A')
    },
    onDelete (index, id) {
      this.notifications.splice(index, 1)
      this.deleteHrNotification(id)
    },
    async deleteHrNotification (id) {
      try {
        await TimeoffNotificationApi.deleteHrNotification(id)
      } catch (err) {
        console.error(err)
      }
    },
    async updateHrNotification (body, id) {
      try {
        await TimeoffNotificationApi.updateHrNotification(body, id)
      } catch (err) {
        console.error(err)
      }
    },
    onReadNotification (item) {
      const {_id, readStatus} = item
      const newReadStatus = readStatus === HR_NOTIFICATION_NO_RAED_STATUS_ID
        ? HR_NOTIFICATION_RAED_STATUS_ID
        : HR_NOTIFICATION_NO_RAED_STATUS_ID
      const body = {
        readStatus: newReadStatus
      }
      item.readStatus = newReadStatus
      this.updateHrNotification(body, _id)
    },
    routerTo ({ project = [], eventNotification }) {
      if (this.USER_NOTIFICATION_REMINDER !== eventNotification) return ''
      if (!project.length) return ''
      const [currentProject = {}] = project
      const { _id } = currentProject

      return {
        name: 'ProjectCard',
        params: {
          projectId: _id
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../sass/variables";

  .bb-notifications-bar-main {
    margin: 0 0 0 -22px;
    position: relative;
  }

  .bb-notifications-bar-main-item {
    padding: 22px 0 22px 22px;
    display: grid;
    grid-template-columns: 27px 1fr;
    grid-gap: 0 13px;
    border-bottom: 1px solid $color-wild-sand;
    position: relative;

    &:hover .bb-notifications-bar-main-item__icon-close {
      opacity: 1;
    }
    &:hover .bb-notifications-bar-main-pointer {
      opacity: 1;
    }

    &__icon-close {
      position: absolute;
      top: 16px;
      right: -7px;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 26px;
      height: 26px;
      font-size: 16px;
      color: $color-silver-deep;
      cursor: pointer;
      transition: 0.3s;
      opacity: 0;

      &:before {
        margin: 0;
      }

      &:hover {
        color: $color-dusty-gray
      }
    }
  }

  .bb-notifications-bar-main-item-right {
    padding: 0 25px 0 0;
    display: grid;
    grid-gap: 7px 0;
    text-decoration: none;
    color: inherit;

    &__title {
      font-size: 14px;
      font-weight: 500;
      line-height: 17px;

      &_capitalize {
        text-transform: capitalize;
      }
    }

    &__description {
      font-size: 12px;
      font-weight: 300;
      line-height: 14px;

      &:first-letter {
        text-transform: capitalize;
      }

      &_gray {
        color: $color-gray;
      }

      &_bold {
        font-weight: 500;
      }
    }

  }

</style>



// WEBPACK FOOTER //
// src/components/Notifications/NotificationsBar/NotificationsBarMain.vue